import axios, { AxiosInstance } from "axios";
import { attachMicrosoftEntraBearer } from "./attachMicrosoftEntraBearer";
import {
  getStoredAccessToken,
  isAccessTokenExpired,
  isAuthEnabled,
  isUnauthorizedHttpStatus,
  redirectToLogin,
} from "./authSession";

axios.defaults.withCredentials = true;
export const axiosInstance: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    "Content-type": "application/json",
  },
});

function rejectIfSessionExpired(): Error | null {
  if (!isAuthEnabled()) {
    return null;
  }
  const token = getStoredAccessToken();
  if (token && isAccessTokenExpired(token)) {
    redirectToLogin();
    return new Error("Session expired");
  }
  return null;
}

axiosInstance.interceptors.request.use(
  (config) => {
    const sessionError = rejectIfSessionExpired();
    if (sessionError) {
      return Promise.reject(sessionError);
    }
    attachMicrosoftEntraBearer(config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (res) => {
    if (isUnauthorizedHttpStatus(res.status)) {
      redirectToLogin();
    }
    return res;
  },
  (err) => {
    if (isUnauthorizedHttpStatus(err.response?.status)) {
      redirectToLogin();
    }
    return Promise.reject(err);
  }
);
